import { gql } from 'apollo-angular';

export const associateAllBuyersWithShoppingList = gql`
    mutation associateAllBuyersWithShoppingList(
        $input: AssociateAllBuyersWithShoppingListInput!
    ) {
        associateAllBuyersWithShoppingList(input: $input) {
            __typename

            ... on AssociateAllBuyersWithShoppingListError {
                errorCode
                message
            }

            ... on AssociateAllBuyersWithShoppingListSuccess {
                success
                message
            }
        }
    }
`;
